import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { mergeMap } from 'rxjs/operators';
import { UserPaypalPaymentsApiService, UserProfileApiService } from 'src/app/api/services';
import { environment } from 'src/environments/environment';
import { CustomSpinnerService } from './custom-spinner.service';
import { EventsService } from './events.service';

@Injectable({
	providedIn: 'root'
})
export class PaypalHelperService {

	constructor(private http: HttpClient,
				private loader: CustomSpinnerService,
				private profileUserService: UserProfileApiService,
				private paypalService: UserPaypalPaymentsApiService,
				private eventService: EventsService) {
	}

	public getAuthToken(token) {
		this.updateProfile(true, '');
	}

	public getPayPalUserInfo(authToken) {
		const customHeaders = {};
		const a = 'Authorization';
		customHeaders[a] = `Bearer ${ authToken }`;
		customHeaders['Content-Type'] = `application/json`;

		let url = 'https://api-m.sandbox.paypal.com/v1/identity/oauth2/userinfo?schema=paypalv1.1';
		if (!environment.ppTest) {
			url = url.replace('.sandbox', '');
		}
		this.http.get(url,
			{ headers: customHeaders }).subscribe(r => {
				// alert(JSON.stringify(r));
				this.updateProfile(r['name'] !== null && r['name'] !== undefined, r['name']);
			},
			error => {
				this.eventService.updatePaypalAuth('failed');
			});
	}

	private updateProfile(verified_account, fullName) {
		if (!verified_account) {
			this.loader.hide().then(() => {
				this.eventService.updatePaypalAuth('failed');
			});
		}
		this.profileUserService.getUserProfile()
			.pipe(
				mergeMap((p) => {
					console.log('save', fullName, p);
					return this.paypalService.verifyPaypalAccount({
						body: {
							userId: p.id,
							verified: true,
							paypalFullName: fullName
						}
					});
				})).subscribe(p => {
			this.loader.hide().then(() => {
				this.eventService.updatePaypalAuth('success');
			});
		}, error => {
			this.eventService.updatePaypalAuth('failed');
		})
	}

	public updateProfileAfterPayment(fullName, onAction) {
		this.profileUserService.getUserProfile()
			.pipe(
				mergeMap((p) => {
					return this.paypalService.verifyPaypalAccount({
						body: {
							userId: p.id,
							verified: true,
							paypalFullName: fullName
						}
					});
				})).subscribe(p => {
			onAction();
		}, error => {
			onAction();
		})
	}


	getParamFromUrl(name, url) {
		name = name.replace(/[\[\]]/g, '\\$&');
		const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
			results = regex.exec(url);
		if (!results) return null;
		if (!results[2]) return '';
		return encodeURIComponent(results[2].replace(/\+/g, ' '));
	}
}

